import { Tag } from 'src/models';
import { Button, Popover } from 'antd';
import { PlusOutlined, TagOutlined } from '@ant-design/icons';
import { useGetTagList } from 'src/hooks/tag';
import { useState } from 'react';
import { SkeletonLoader } from '@insight-health-ai/roseate/components';
import { InsightTag } from 'src/components';
type TagSelectorProps = {
  selectedTags?: Tag[] | null;
  onAdd: (tag: Tag) => void;
  onRemove: (tag: Tag) => void;
};

export const TagSelector = ({
  selectedTags,
  onAdd,
  onRemove,
}: TagSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { data, isLoading: isTagListLoading } = useGetTagList(
    {},
    { enabled: isOpen }
  );

  const tagList = data?.groupedTags || {};

  const renderTagList = () => {
    if (isTagListLoading) {
      return <SkeletonLoader active />;
    }

    return (
      <>
        <div className="flex items-center gap-2 font-medium">
          <TagOutlined /> Add tags by category
        </div>
        <div className="flex flex-col gap-4">
          {Object.entries(tagList).map(([category, tags]) => (
            <div key={category} className="flex flex-col gap-1">
              <div className="text-xs text-gray-600 font-semibold">
                {category}
              </div>
              <div className="flex flex-wrap gap-2">
                {tags.map((tag: Tag) => {
                  const isSelected = selectedTags?.some((t) => t.id === tag.id);
                  const props = isSelected
                    ? {
                        onClose: () => onRemove(tag),
                      }
                    : {
                        onClick: () => onAdd(tag),
                      };
                  return (
                    <InsightTag
                      key={tag.id}
                      tag={tag}
                      isSelected={!!isSelected}
                      {...props}
                    />
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <Popover
      open={isOpen}
      trigger="click"
      placement="bottomRight"
      onOpenChange={setIsOpen}
      classNames={{
        body: 'min-w-[200px] max-w-[320px] max-h-[320px] overflow-auto',
      }}
      content={<div className="flex flex-col gap-4">{renderTagList()}</div>}
    >
      <Button
        type="text"
        className="border border-gray-300 h-[20px]"
        size="small"
      >
        <PlusOutlined className="text-xs" />
      </Button>
    </Popover>
  );
};
